// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    projectId: 'kefc-8ff14',
    appId: '1:1067350129468:web:eb760a288e32ca23467c39',
    storageBucket: 'kefc-8ff14.appspot.com',
    locationId: 'us-central',
    apiKey: 'AIzaSyDVBOsBaRB-DTbYapPTbABxmrCcNjBm2Ko',
    authDomain: 'kefc-8ff14.firebaseapp.com',
    messagingSenderId: '1067350129468',
    measurementId: 'G-3NSBQFMPSF',
  },
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
